export default from './text-editor-video-embed-modal';



// WEBPACK FOOTER //
// ./app/containers/text-editor-video-embed-modal/index.js